import {Component, OnInit, DestroyRef, inject, signal, effect} from '@angular/core';
import {TrackTraceRestService} from "../../../core/track-trace/services/track.trace.rest.service";
import {TrackTraceRequest} from "../../../core/track-trace/api/track.trace.request";
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatIconModule} from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import {UserService} from "../../../core/user/services/user.service";
import {ArrivalRangePipe} from "../../../core/pipes/arrivalRange.pipe";
@Component({
    selector: 'app-track-trace-widget',
    templateUrl: './track-trace-widget.component.html',
    styleUrl: './track-trace-widget.component.scss',
  imports: [
    MatProgressSpinnerModule,
    MatIconModule,
    RouterLink,
    MatTableModule,
CommonModule,
    ArrivalRangePipe
  ],
})
export class TrackTraceWidgetComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private userService: UserService = inject(UserService);
  private trackTraceRestService: TrackTraceRestService = inject(TrackTraceRestService);
  displayedColumns: string[] = ['tour', 'arrival', 'status'];

  tours: any[] = [];
  loading = false;
  now = new Date();

  private intervalId?: number;

  constructor() {
    effect(() => {
      const idf = this.userService.selectedIdf();
      if (idf) {
        this.loadTours();
      }
    });
  }

  ngOnInit() {
    this.loadTours();

    this.intervalId = window.setInterval(() => {
      this.loadTours();
    }, 300000);

    this.destroyRef.onDestroy(() => {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    });
  }

  loadTours() {
    this.loading = true;
    this.trackTraceRestService.getTours(
      new TrackTraceRequest(21, this.userService.selectedIdf(), this.now.toISOString().split('T')[0], false)
    )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (tours: any) => {
          this.tours = tours.return_object.tour_information.tour;
          this.loading = false;
        },
        error: (error: any) => {
          this.loading = false;
        }
      });
  }

  delay(tour: any) : string {
    const delay = Math.abs(tour.delay_in_minutes);

    if(delay) {
      if(delay > 30)
        return 'text-danger';
      else if( delay >= 10)
        return 'text-alert';
      else
        return 'text-success';
    }
    return 'no';
  }

  protected checkDelay(item: any): string {
    if (!item) {
      return 'time';
    }

    const delayMinutes = item.delay_in_minutes ?? 0;

    if (delayMinutes >= 30) {
      return 'time warning';
    }

    if (delayMinutes > 10 && delayMinutes < 30) {
      return 'time alerting';
    }

    return 'time';
  }

  protected getDepartureTimeAndStation(tourId: string): string {
    const departureHour = Number(tourId.slice(0, 2)) % 24;
    const departureMin = tourId.slice(2, 4);
    const station = tourId.slice(4, 6);
    const departureTime = `${departureHour.toString().padStart(2, '0')}:${departureMin}`;

    return `${departureTime}/${station}`;
  }
}
